import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Header from '../../containers/DefaultLayout/Header';

import LinkRouter from '../../components/LinkRouter';

const NotFound = () => {
    return (
        <>
            <Header />
            <Container component="main"
                sx={{
                    maxWidth: { lg: "1310px", md: "744px", xs: "364px" },
                    marginTop: "153px",
                    textAlign: "center",
                }}
            >
                <Box>
                    <Typography color="inherit" fontSize="150px" lineHeight="188px" fontWeight="600" sx={{ marginBottom: "20px" }}>404</Typography>
                    <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" color="primary.main" sx={{ marginBottom: "20px" }}>Сторінка не знайдена</Typography>
                    <Typography variant="h4" fontFamily="Fixel Display" color="inherit" fontWeight="medium" sx={{ marginBottom: "95px" }}>
                        На жаль, сторінка, яку ви запитували, не знайдена.
                        <br />
                        Будь ласка, поверніться на головну сторінку.
                    </Typography>
                    <LinkRouter underline="none" to="/">
                        <Button
                            variant="contained"
                            sx={{
                                fontSize: "20px",
                                lineHeight: "25px",
                                fontWeight: "500",
                                borderRadius: "10px",
                                px: "65px",
                                py: "15px",
                                textTransform: "none",
                            }}
                        >
                            Головна
                        </Button>
                    </LinkRouter>
                </Box>
            </ Container>
        </>
    );
}

export default NotFound;